import { Action } from 'redux';

import * as actions from './actions';

import { ErrorAction } from '../common/error-action';
import { LoadingAction } from '../common/loading-action';
import ArtistPreset from '@common/types/artist-preset/artist-preset';

export class GetArtistPresets implements LoadingAction {
  readonly type = actions.GET_ARTIST_PRESETS;
  readonly isLoading = true;
  readonly mainLoader = true;
}

export class GetArtistPresetsSuccess implements LoadingAction {
  readonly type = actions.GET_ARTIST_PRESETS_SUCCESS;
  readonly isLoading = false;

  constructor(public presets: ArtistPreset) {}
}

export class GetArtistPresetsError implements ErrorAction {
  readonly type = actions.GET_ARTIST_PRESETS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateArtistPresets implements LoadingAction {
  readonly type = actions.UPDATE_ARTIST_PRESETS;
  readonly isLoading = true;

  constructor(public presets: ArtistPreset) {}
}

export class UpdateArtistPresetsSuccess implements LoadingAction {
  readonly type = actions.UPDATE_ARTIST_PRESETS_SUCCESS;
  readonly isLoading = false;

  constructor(public presets: ArtistPreset) {}
}

export class UpdateArtistPresetsError implements ErrorAction {
  readonly type = actions.UPDATE_ARTIST_PRESETS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateArtistPresetsField<T extends keyof ArtistPreset>
  implements Action {
  readonly type = actions.UPDATE_ARTIST_PRESETS_FIELD;

  constructor(public field: T, public value: ArtistPreset[T]) {}
}

export type ArtistPresetsActions =
  | GetArtistPresets
  | GetArtistPresetsSuccess
  | GetArtistPresetsError
  | UpdateArtistPresets
  | UpdateArtistPresetsSuccess
  | UpdateArtistPresetsError
  | UpdateArtistPresetsField<keyof ArtistPreset>;
